import { gql } from "@apollo/client";


export const REALLOCATE_INTERNAL_DRIVER_JOB = gql`
  query reallocateInternalDriverJob($jobId: String!) {
    reallocateInternalDriverJob(jobId: $jobId) {
      id
    }
  }
`;